import React from 'react';
import { NXT_CRM, DONORPERFECT_CRM } from 'src/utils/authOrg.constants';

import ConnectNXT from './ConnectNXT';
import ConnectDonorPerfect from './ConnectDonorPerfect';

const ConnectCRM = props => {
	if (props.authOrganizations[0].crm_type === NXT_CRM) {
		return <ConnectNXT {...props} />;
	}
	if (props.authOrganizations[0].crm_type === DONORPERFECT_CRM) {
		return <ConnectDonorPerfect {...props} />;
	}
};

export default ConnectCRM;



// WEBPACK FOOTER //
// ./src/ConnectedComponents/Setup/ConnectCRM/index.js